export const UserRoleEnum = {
    DEVELOPER: 'developer',
    IT_SYSTEM_ADMIN: 'it system admin',
    OPS_ADMIN: 'ops admin',
    OPS_ADMIN_W_IMPERSONATION: 'ops admin (w/ impersonation)'
}

export const UserStatusEnum = {
    ACTIVE: 'active',
    DEACTIVE: 'deactive',
    ARCHIVE: 'archive',
    DELETE: 'delete'
}